var map = {
	"./128x128/abkhazia.png": "./src/assets/images/flags/128x128/abkhazia.png",
	"./128x128/ad.png": "./src/assets/images/flags/128x128/ad.png",
	"./128x128/ae.png": "./src/assets/images/flags/128x128/ae.png",
	"./128x128/af.png": "./src/assets/images/flags/128x128/af.png",
	"./128x128/ag.png": "./src/assets/images/flags/128x128/ag.png",
	"./128x128/ai.png": "./src/assets/images/flags/128x128/ai.png",
	"./128x128/al.png": "./src/assets/images/flags/128x128/al.png",
	"./128x128/am.png": "./src/assets/images/flags/128x128/am.png",
	"./128x128/ao.png": "./src/assets/images/flags/128x128/ao.png",
	"./128x128/aq.png": "./src/assets/images/flags/128x128/aq.png",
	"./128x128/ar.png": "./src/assets/images/flags/128x128/ar.png",
	"./128x128/as.png": "./src/assets/images/flags/128x128/as.png",
	"./128x128/at.png": "./src/assets/images/flags/128x128/at.png",
	"./128x128/au.png": "./src/assets/images/flags/128x128/au.png",
	"./128x128/aw.png": "./src/assets/images/flags/128x128/aw.png",
	"./128x128/ax.png": "./src/assets/images/flags/128x128/ax.png",
	"./128x128/az.png": "./src/assets/images/flags/128x128/az.png",
	"./128x128/azores islands.png": "./src/assets/images/flags/128x128/azores islands.png",
	"./128x128/ba.png": "./src/assets/images/flags/128x128/ba.png",
	"./128x128/balearic islands.png": "./src/assets/images/flags/128x128/balearic islands.png",
	"./128x128/basque country.png": "./src/assets/images/flags/128x128/basque country.png",
	"./128x128/bb.png": "./src/assets/images/flags/128x128/bb.png",
	"./128x128/bd.png": "./src/assets/images/flags/128x128/bd.png",
	"./128x128/be.png": "./src/assets/images/flags/128x128/be.png",
	"./128x128/bf.png": "./src/assets/images/flags/128x128/bf.png",
	"./128x128/bg.png": "./src/assets/images/flags/128x128/bg.png",
	"./128x128/bh.png": "./src/assets/images/flags/128x128/bh.png",
	"./128x128/bhutan.png": "./src/assets/images/flags/128x128/bhutan.png",
	"./128x128/bi.png": "./src/assets/images/flags/128x128/bi.png",
	"./128x128/bj.png": "./src/assets/images/flags/128x128/bj.png",
	"./128x128/bl.png": "./src/assets/images/flags/128x128/bl.png",
	"./128x128/bm.png": "./src/assets/images/flags/128x128/bm.png",
	"./128x128/bn.png": "./src/assets/images/flags/128x128/bn.png",
	"./128x128/bo.png": "./src/assets/images/flags/128x128/bo.png",
	"./128x128/bq.png": "./src/assets/images/flags/128x128/bq.png",
	"./128x128/br.png": "./src/assets/images/flags/128x128/br.png",
	"./128x128/british columbia.png": "./src/assets/images/flags/128x128/british columbia.png",
	"./128x128/bs.png": "./src/assets/images/flags/128x128/bs.png",
	"./128x128/bt.png": "./src/assets/images/flags/128x128/bt.png",
	"./128x128/bv.png": "./src/assets/images/flags/128x128/bv.png",
	"./128x128/bw.png": "./src/assets/images/flags/128x128/bw.png",
	"./128x128/by.png": "./src/assets/images/flags/128x128/by.png",
	"./128x128/bz.png": "./src/assets/images/flags/128x128/bz.png",
	"./128x128/ca.png": "./src/assets/images/flags/128x128/ca.png",
	"./128x128/canary islands.png": "./src/assets/images/flags/128x128/canary islands.png",
	"./128x128/cc.png": "./src/assets/images/flags/128x128/cc.png",
	"./128x128/cd.png": "./src/assets/images/flags/128x128/cd.png",
	"./128x128/ceuta.png": "./src/assets/images/flags/128x128/ceuta.png",
	"./128x128/cf.png": "./src/assets/images/flags/128x128/cf.png",
	"./128x128/cg.png": "./src/assets/images/flags/128x128/cg.png",
	"./128x128/ch.png": "./src/assets/images/flags/128x128/ch.png",
	"./128x128/ci.png": "./src/assets/images/flags/128x128/ci.png",
	"./128x128/ck.png": "./src/assets/images/flags/128x128/ck.png",
	"./128x128/cl.png": "./src/assets/images/flags/128x128/cl.png",
	"./128x128/cm.png": "./src/assets/images/flags/128x128/cm.png",
	"./128x128/cn.png": "./src/assets/images/flags/128x128/cn.png",
	"./128x128/co.png": "./src/assets/images/flags/128x128/co.png",
	"./128x128/corsica.png": "./src/assets/images/flags/128x128/corsica.png",
	"./128x128/cr.png": "./src/assets/images/flags/128x128/cr.png",
	"./128x128/cu.png": "./src/assets/images/flags/128x128/cu.png",
	"./128x128/cv.png": "./src/assets/images/flags/128x128/cv.png",
	"./128x128/cw.png": "./src/assets/images/flags/128x128/cw.png",
	"./128x128/cx.png": "./src/assets/images/flags/128x128/cx.png",
	"./128x128/cy.png": "./src/assets/images/flags/128x128/cy.png",
	"./128x128/cz.png": "./src/assets/images/flags/128x128/cz.png",
	"./128x128/de.png": "./src/assets/images/flags/128x128/de.png",
	"./128x128/dj.png": "./src/assets/images/flags/128x128/dj.png",
	"./128x128/dk.png": "./src/assets/images/flags/128x128/dk.png",
	"./128x128/dm.png": "./src/assets/images/flags/128x128/dm.png",
	"./128x128/do.png": "./src/assets/images/flags/128x128/do.png",
	"./128x128/dz.png": "./src/assets/images/flags/128x128/dz.png",
	"./128x128/ec.png": "./src/assets/images/flags/128x128/ec.png",
	"./128x128/ee.png": "./src/assets/images/flags/128x128/ee.png",
	"./128x128/eg.png": "./src/assets/images/flags/128x128/eg.png",
	"./128x128/eh.png": "./src/assets/images/flags/128x128/eh.png",
	"./128x128/england.png": "./src/assets/images/flags/128x128/england.png",
	"./128x128/er.png": "./src/assets/images/flags/128x128/er.png",
	"./128x128/es.png": "./src/assets/images/flags/128x128/es.png",
	"./128x128/et.png": "./src/assets/images/flags/128x128/et.png",
	"./128x128/european union.png": "./src/assets/images/flags/128x128/european union.png",
	"./128x128/fi.png": "./src/assets/images/flags/128x128/fi.png",
	"./128x128/fj.png": "./src/assets/images/flags/128x128/fj.png",
	"./128x128/fk.png": "./src/assets/images/flags/128x128/fk.png",
	"./128x128/fm.png": "./src/assets/images/flags/128x128/fm.png",
	"./128x128/fo.png": "./src/assets/images/flags/128x128/fo.png",
	"./128x128/fr.png": "./src/assets/images/flags/128x128/fr.png",
	"./128x128/ga.png": "./src/assets/images/flags/128x128/ga.png",
	"./128x128/galapagos islands.png": "./src/assets/images/flags/128x128/galapagos islands.png",
	"./128x128/gb.png": "./src/assets/images/flags/128x128/gb.png",
	"./128x128/gd.png": "./src/assets/images/flags/128x128/gd.png",
	"./128x128/ge.png": "./src/assets/images/flags/128x128/ge.png",
	"./128x128/gg.png": "./src/assets/images/flags/128x128/gg.png",
	"./128x128/gh.png": "./src/assets/images/flags/128x128/gh.png",
	"./128x128/gi.png": "./src/assets/images/flags/128x128/gi.png",
	"./128x128/gl.png": "./src/assets/images/flags/128x128/gl.png",
	"./128x128/gm.png": "./src/assets/images/flags/128x128/gm.png",
	"./128x128/gn.png": "./src/assets/images/flags/128x128/gn.png",
	"./128x128/gp.png": "./src/assets/images/flags/128x128/gp.png",
	"./128x128/gq.png": "./src/assets/images/flags/128x128/gq.png",
	"./128x128/gr.png": "./src/assets/images/flags/128x128/gr.png",
	"./128x128/gt.png": "./src/assets/images/flags/128x128/gt.png",
	"./128x128/gu.png": "./src/assets/images/flags/128x128/gu.png",
	"./128x128/gw.png": "./src/assets/images/flags/128x128/gw.png",
	"./128x128/gy.png": "./src/assets/images/flags/128x128/gy.png",
	"./128x128/hawaii.png": "./src/assets/images/flags/128x128/hawaii.png",
	"./128x128/hk.png": "./src/assets/images/flags/128x128/hk.png",
	"./128x128/hn.png": "./src/assets/images/flags/128x128/hn.png",
	"./128x128/hr.png": "./src/assets/images/flags/128x128/hr.png",
	"./128x128/ht.png": "./src/assets/images/flags/128x128/ht.png",
	"./128x128/hu.png": "./src/assets/images/flags/128x128/hu.png",
	"./128x128/id.png": "./src/assets/images/flags/128x128/id.png",
	"./128x128/ie.png": "./src/assets/images/flags/128x128/ie.png",
	"./128x128/il.png": "./src/assets/images/flags/128x128/il.png",
	"./128x128/im.png": "./src/assets/images/flags/128x128/im.png",
	"./128x128/in.png": "./src/assets/images/flags/128x128/in.png",
	"./128x128/io.png": "./src/assets/images/flags/128x128/io.png",
	"./128x128/iq.png": "./src/assets/images/flags/128x128/iq.png",
	"./128x128/ir.png": "./src/assets/images/flags/128x128/ir.png",
	"./128x128/is.png": "./src/assets/images/flags/128x128/is.png",
	"./128x128/it.png": "./src/assets/images/flags/128x128/it.png",
	"./128x128/je.png": "./src/assets/images/flags/128x128/je.png",
	"./128x128/jm.png": "./src/assets/images/flags/128x128/jm.png",
	"./128x128/jo.png": "./src/assets/images/flags/128x128/jo.png",
	"./128x128/jp.png": "./src/assets/images/flags/128x128/jp.png",
	"./128x128/ke.png": "./src/assets/images/flags/128x128/ke.png",
	"./128x128/kg.png": "./src/assets/images/flags/128x128/kg.png",
	"./128x128/kh.png": "./src/assets/images/flags/128x128/kh.png",
	"./128x128/ki.png": "./src/assets/images/flags/128x128/ki.png",
	"./128x128/km.png": "./src/assets/images/flags/128x128/km.png",
	"./128x128/kn.png": "./src/assets/images/flags/128x128/kn.png",
	"./128x128/kp.png": "./src/assets/images/flags/128x128/kp.png",
	"./128x128/kr.png": "./src/assets/images/flags/128x128/kr.png",
	"./128x128/kw.png": "./src/assets/images/flags/128x128/kw.png",
	"./128x128/ky.png": "./src/assets/images/flags/128x128/ky.png",
	"./128x128/kz.png": "./src/assets/images/flags/128x128/kz.png",
	"./128x128/la.png": "./src/assets/images/flags/128x128/la.png",
	"./128x128/lb.png": "./src/assets/images/flags/128x128/lb.png",
	"./128x128/lc.png": "./src/assets/images/flags/128x128/lc.png",
	"./128x128/li.png": "./src/assets/images/flags/128x128/li.png",
	"./128x128/lk.png": "./src/assets/images/flags/128x128/lk.png",
	"./128x128/lr.png": "./src/assets/images/flags/128x128/lr.png",
	"./128x128/ls.png": "./src/assets/images/flags/128x128/ls.png",
	"./128x128/lt.png": "./src/assets/images/flags/128x128/lt.png",
	"./128x128/lu.png": "./src/assets/images/flags/128x128/lu.png",
	"./128x128/lv.png": "./src/assets/images/flags/128x128/lv.png",
	"./128x128/ly.png": "./src/assets/images/flags/128x128/ly.png",
	"./128x128/ma.png": "./src/assets/images/flags/128x128/ma.png",
	"./128x128/madeira.png": "./src/assets/images/flags/128x128/madeira.png",
	"./128x128/mc.png": "./src/assets/images/flags/128x128/mc.png",
	"./128x128/md.png": "./src/assets/images/flags/128x128/md.png",
	"./128x128/me.png": "./src/assets/images/flags/128x128/me.png",
	"./128x128/melilla.png": "./src/assets/images/flags/128x128/melilla.png",
	"./128x128/mg.png": "./src/assets/images/flags/128x128/mg.png",
	"./128x128/mh.png": "./src/assets/images/flags/128x128/mh.png",
	"./128x128/mk.png": "./src/assets/images/flags/128x128/mk.png",
	"./128x128/ml.png": "./src/assets/images/flags/128x128/ml.png",
	"./128x128/mm.png": "./src/assets/images/flags/128x128/mm.png",
	"./128x128/mn.png": "./src/assets/images/flags/128x128/mn.png",
	"./128x128/mo.png": "./src/assets/images/flags/128x128/mo.png",
	"./128x128/mp.png": "./src/assets/images/flags/128x128/mp.png",
	"./128x128/mq.png": "./src/assets/images/flags/128x128/mq.png",
	"./128x128/mr.png": "./src/assets/images/flags/128x128/mr.png",
	"./128x128/ms.png": "./src/assets/images/flags/128x128/ms.png",
	"./128x128/mt.png": "./src/assets/images/flags/128x128/mt.png",
	"./128x128/mu.png": "./src/assets/images/flags/128x128/mu.png",
	"./128x128/mv.png": "./src/assets/images/flags/128x128/mv.png",
	"./128x128/mw.png": "./src/assets/images/flags/128x128/mw.png",
	"./128x128/mx.png": "./src/assets/images/flags/128x128/mx.png",
	"./128x128/my.png": "./src/assets/images/flags/128x128/my.png",
	"./128x128/mz.png": "./src/assets/images/flags/128x128/mz.png",
	"./128x128/na.png": "./src/assets/images/flags/128x128/na.png",
	"./128x128/nato.png": "./src/assets/images/flags/128x128/nato.png",
	"./128x128/nc.png": "./src/assets/images/flags/128x128/nc.png",
	"./128x128/ne.png": "./src/assets/images/flags/128x128/ne.png",
	"./128x128/nf.png": "./src/assets/images/flags/128x128/nf.png",
	"./128x128/ng.png": "./src/assets/images/flags/128x128/ng.png",
	"./128x128/ni.png": "./src/assets/images/flags/128x128/ni.png",
	"./128x128/nl.png": "./src/assets/images/flags/128x128/nl.png",
	"./128x128/no.png": "./src/assets/images/flags/128x128/no.png",
	"./128x128/northen-cyprus.png": "./src/assets/images/flags/128x128/northen-cyprus.png",
	"./128x128/np.png": "./src/assets/images/flags/128x128/np.png",
	"./128x128/nr.png": "./src/assets/images/flags/128x128/nr.png",
	"./128x128/nu.png": "./src/assets/images/flags/128x128/nu.png",
	"./128x128/nz.png": "./src/assets/images/flags/128x128/nz.png",
	"./128x128/om.png": "./src/assets/images/flags/128x128/om.png",
	"./128x128/orkney islands.png": "./src/assets/images/flags/128x128/orkney islands.png",
	"./128x128/ossetia.png": "./src/assets/images/flags/128x128/ossetia.png",
	"./128x128/pa.png": "./src/assets/images/flags/128x128/pa.png",
	"./128x128/pe.png": "./src/assets/images/flags/128x128/pe.png",
	"./128x128/pf.png": "./src/assets/images/flags/128x128/pf.png",
	"./128x128/pg.png": "./src/assets/images/flags/128x128/pg.png",
	"./128x128/ph.png": "./src/assets/images/flags/128x128/ph.png",
	"./128x128/pk.png": "./src/assets/images/flags/128x128/pk.png",
	"./128x128/pl.png": "./src/assets/images/flags/128x128/pl.png",
	"./128x128/pn.png": "./src/assets/images/flags/128x128/pn.png",
	"./128x128/pr.png": "./src/assets/images/flags/128x128/pr.png",
	"./128x128/ps.png": "./src/assets/images/flags/128x128/ps.png",
	"./128x128/pt.png": "./src/assets/images/flags/128x128/pt.png",
	"./128x128/pw.png": "./src/assets/images/flags/128x128/pw.png",
	"./128x128/py.png": "./src/assets/images/flags/128x128/py.png",
	"./128x128/qa.png": "./src/assets/images/flags/128x128/qa.png",
	"./128x128/rapa nui.png": "./src/assets/images/flags/128x128/rapa nui.png",
	"./128x128/ro.png": "./src/assets/images/flags/128x128/ro.png",
	"./128x128/rs.png": "./src/assets/images/flags/128x128/rs.png",
	"./128x128/ru.png": "./src/assets/images/flags/128x128/ru.png",
	"./128x128/rw.png": "./src/assets/images/flags/128x128/rw.png",
	"./128x128/sa.png": "./src/assets/images/flags/128x128/sa.png",
	"./128x128/saba island.png": "./src/assets/images/flags/128x128/saba island.png",
	"./128x128/sardinia.png": "./src/assets/images/flags/128x128/sardinia.png",
	"./128x128/sb.png": "./src/assets/images/flags/128x128/sb.png",
	"./128x128/sc.png": "./src/assets/images/flags/128x128/sc.png",
	"./128x128/scotland.png": "./src/assets/images/flags/128x128/scotland.png",
	"./128x128/sd.png": "./src/assets/images/flags/128x128/sd.png",
	"./128x128/se.png": "./src/assets/images/flags/128x128/se.png",
	"./128x128/sg.png": "./src/assets/images/flags/128x128/sg.png",
	"./128x128/sh.png": "./src/assets/images/flags/128x128/sh.png",
	"./128x128/si.png": "./src/assets/images/flags/128x128/si.png",
	"./128x128/sint eustatius.png": "./src/assets/images/flags/128x128/sint eustatius.png",
	"./128x128/sj.png": "./src/assets/images/flags/128x128/sj.png",
	"./128x128/sk.png": "./src/assets/images/flags/128x128/sk.png",
	"./128x128/sl.png": "./src/assets/images/flags/128x128/sl.png",
	"./128x128/sm.png": "./src/assets/images/flags/128x128/sm.png",
	"./128x128/sn.png": "./src/assets/images/flags/128x128/sn.png",
	"./128x128/so.png": "./src/assets/images/flags/128x128/so.png",
	"./128x128/somaliland.png": "./src/assets/images/flags/128x128/somaliland.png",
	"./128x128/sr.png": "./src/assets/images/flags/128x128/sr.png",
	"./128x128/ss.png": "./src/assets/images/flags/128x128/ss.png",
	"./128x128/st.png": "./src/assets/images/flags/128x128/st.png",
	"./128x128/sv.png": "./src/assets/images/flags/128x128/sv.png",
	"./128x128/sx.png": "./src/assets/images/flags/128x128/sx.png",
	"./128x128/sy.png": "./src/assets/images/flags/128x128/sy.png",
	"./128x128/sz.png": "./src/assets/images/flags/128x128/sz.png",
	"./128x128/tc.png": "./src/assets/images/flags/128x128/tc.png",
	"./128x128/td.png": "./src/assets/images/flags/128x128/td.png",
	"./128x128/tg.png": "./src/assets/images/flags/128x128/tg.png",
	"./128x128/th.png": "./src/assets/images/flags/128x128/th.png",
	"./128x128/tibet.png": "./src/assets/images/flags/128x128/tibet.png",
	"./128x128/tj.png": "./src/assets/images/flags/128x128/tj.png",
	"./128x128/tk.png": "./src/assets/images/flags/128x128/tk.png",
	"./128x128/tl.png": "./src/assets/images/flags/128x128/tl.png",
	"./128x128/tm.png": "./src/assets/images/flags/128x128/tm.png",
	"./128x128/tn.png": "./src/assets/images/flags/128x128/tn.png",
	"./128x128/to.png": "./src/assets/images/flags/128x128/to.png",
	"./128x128/tr.png": "./src/assets/images/flags/128x128/tr.png",
	"./128x128/transnistria.png": "./src/assets/images/flags/128x128/transnistria.png",
	"./128x128/tt.png": "./src/assets/images/flags/128x128/tt.png",
	"./128x128/tv.png": "./src/assets/images/flags/128x128/tv.png",
	"./128x128/tw.png": "./src/assets/images/flags/128x128/tw.png",
	"./128x128/tz.png": "./src/assets/images/flags/128x128/tz.png",
	"./128x128/ua.png": "./src/assets/images/flags/128x128/ua.png",
	"./128x128/ug.png": "./src/assets/images/flags/128x128/ug.png",
	"./128x128/um.png": "./src/assets/images/flags/128x128/um.png",
	"./128x128/united nations.png": "./src/assets/images/flags/128x128/united nations.png",
	"./128x128/us.png": "./src/assets/images/flags/128x128/us.png",
	"./128x128/uy.png": "./src/assets/images/flags/128x128/uy.png",
	"./128x128/uz.png": "./src/assets/images/flags/128x128/uz.png",
	"./128x128/va.png": "./src/assets/images/flags/128x128/va.png",
	"./128x128/vc.png": "./src/assets/images/flags/128x128/vc.png",
	"./128x128/ve.png": "./src/assets/images/flags/128x128/ve.png",
	"./128x128/vg.png": "./src/assets/images/flags/128x128/vg.png",
	"./128x128/vi.png": "./src/assets/images/flags/128x128/vi.png",
	"./128x128/vn.png": "./src/assets/images/flags/128x128/vn.png",
	"./128x128/vu.png": "./src/assets/images/flags/128x128/vu.png",
	"./128x128/wales.png": "./src/assets/images/flags/128x128/wales.png",
	"./128x128/wf.png": "./src/assets/images/flags/128x128/wf.png",
	"./128x128/ws.png": "./src/assets/images/flags/128x128/ws.png",
	"./128x128/xk.png": "./src/assets/images/flags/128x128/xk.png",
	"./128x128/xx.png": "./src/assets/images/flags/128x128/xx.png",
	"./128x128/ye.png": "./src/assets/images/flags/128x128/ye.png",
	"./128x128/yt.png": "./src/assets/images/flags/128x128/yt.png",
	"./128x128/za.png": "./src/assets/images/flags/128x128/za.png",
	"./128x128/zm.png": "./src/assets/images/flags/128x128/zm.png",
	"./128x128/zw.png": "./src/assets/images/flags/128x128/zw.png",
	"./128x128/zz.png": "./src/assets/images/flags/128x128/zz.png",
	"./BHS.png": "./src/assets/images/flags/BHS.png",
	"./PAN.png": "./src/assets/images/flags/PAN.png",
	"./abkhazia.png": "./src/assets/images/flags/abkhazia.png",
	"./ad.png": "./src/assets/images/flags/ad.png",
	"./ae.png": "./src/assets/images/flags/ae.png",
	"./af.png": "./src/assets/images/flags/af.png",
	"./ag.png": "./src/assets/images/flags/ag.png",
	"./ai.png": "./src/assets/images/flags/ai.png",
	"./al.png": "./src/assets/images/flags/al.png",
	"./am.png": "./src/assets/images/flags/am.png",
	"./ao.png": "./src/assets/images/flags/ao.png",
	"./aq.png": "./src/assets/images/flags/aq.png",
	"./ar.png": "./src/assets/images/flags/ar.png",
	"./as.png": "./src/assets/images/flags/as.png",
	"./at.png": "./src/assets/images/flags/at.png",
	"./au.png": "./src/assets/images/flags/au.png",
	"./aw.png": "./src/assets/images/flags/aw.png",
	"./ax.png": "./src/assets/images/flags/ax.png",
	"./az.png": "./src/assets/images/flags/az.png",
	"./azores islands.png": "./src/assets/images/flags/azores islands.png",
	"./ba.png": "./src/assets/images/flags/ba.png",
	"./balearic islands.png": "./src/assets/images/flags/balearic islands.png",
	"./basque country.png": "./src/assets/images/flags/basque country.png",
	"./bb.png": "./src/assets/images/flags/bb.png",
	"./bd.png": "./src/assets/images/flags/bd.png",
	"./be.png": "./src/assets/images/flags/be.png",
	"./bf.png": "./src/assets/images/flags/bf.png",
	"./bg.png": "./src/assets/images/flags/bg.png",
	"./bh.png": "./src/assets/images/flags/bh.png",
	"./bhutan.png": "./src/assets/images/flags/bhutan.png",
	"./bi.png": "./src/assets/images/flags/bi.png",
	"./bj.png": "./src/assets/images/flags/bj.png",
	"./bl.png": "./src/assets/images/flags/bl.png",
	"./bm.png": "./src/assets/images/flags/bm.png",
	"./bn.png": "./src/assets/images/flags/bn.png",
	"./bo.png": "./src/assets/images/flags/bo.png",
	"./bq.png": "./src/assets/images/flags/bq.png",
	"./br.png": "./src/assets/images/flags/br.png",
	"./british columbia.png": "./src/assets/images/flags/british columbia.png",
	"./bs.png": "./src/assets/images/flags/bs.png",
	"./bt.png": "./src/assets/images/flags/bt.png",
	"./bv.png": "./src/assets/images/flags/bv.png",
	"./bw.png": "./src/assets/images/flags/bw.png",
	"./by.png": "./src/assets/images/flags/by.png",
	"./bz.png": "./src/assets/images/flags/bz.png",
	"./ca.png": "./src/assets/images/flags/ca.png",
	"./canary islands.png": "./src/assets/images/flags/canary islands.png",
	"./cc.png": "./src/assets/images/flags/cc.png",
	"./cd.png": "./src/assets/images/flags/cd.png",
	"./ceuta.png": "./src/assets/images/flags/ceuta.png",
	"./cf.png": "./src/assets/images/flags/cf.png",
	"./cg.png": "./src/assets/images/flags/cg.png",
	"./ch.png": "./src/assets/images/flags/ch.png",
	"./ci.png": "./src/assets/images/flags/ci.png",
	"./ck.png": "./src/assets/images/flags/ck.png",
	"./cl.png": "./src/assets/images/flags/cl.png",
	"./cm.png": "./src/assets/images/flags/cm.png",
	"./cn.png": "./src/assets/images/flags/cn.png",
	"./co.png": "./src/assets/images/flags/co.png",
	"./corsica.png": "./src/assets/images/flags/corsica.png",
	"./cr.png": "./src/assets/images/flags/cr.png",
	"./cu.png": "./src/assets/images/flags/cu.png",
	"./cv.png": "./src/assets/images/flags/cv.png",
	"./cw.png": "./src/assets/images/flags/cw.png",
	"./cx.png": "./src/assets/images/flags/cx.png",
	"./cy.png": "./src/assets/images/flags/cy.png",
	"./cz.png": "./src/assets/images/flags/cz.png",
	"./de.png": "./src/assets/images/flags/de.png",
	"./default.png": "./src/assets/images/flags/default.png",
	"./dj.png": "./src/assets/images/flags/dj.png",
	"./dk.png": "./src/assets/images/flags/dk.png",
	"./dm.png": "./src/assets/images/flags/dm.png",
	"./do.png": "./src/assets/images/flags/do.png",
	"./dz.png": "./src/assets/images/flags/dz.png",
	"./ec.png": "./src/assets/images/flags/ec.png",
	"./ee.png": "./src/assets/images/flags/ee.png",
	"./eg.png": "./src/assets/images/flags/eg.png",
	"./eh.png": "./src/assets/images/flags/eh.png",
	"./england.png": "./src/assets/images/flags/england.png",
	"./er.png": "./src/assets/images/flags/er.png",
	"./es.png": "./src/assets/images/flags/es.png",
	"./et.png": "./src/assets/images/flags/et.png",
	"./european union.png": "./src/assets/images/flags/european union.png",
	"./fi.png": "./src/assets/images/flags/fi.png",
	"./fj.png": "./src/assets/images/flags/fj.png",
	"./fk.png": "./src/assets/images/flags/fk.png",
	"./fm.png": "./src/assets/images/flags/fm.png",
	"./fo.png": "./src/assets/images/flags/fo.png",
	"./fr.png": "./src/assets/images/flags/fr.png",
	"./ga.png": "./src/assets/images/flags/ga.png",
	"./galapagos islands.png": "./src/assets/images/flags/galapagos islands.png",
	"./gb.png": "./src/assets/images/flags/gb.png",
	"./gd.png": "./src/assets/images/flags/gd.png",
	"./ge.png": "./src/assets/images/flags/ge.png",
	"./gf.png": "./src/assets/images/flags/gf.png",
	"./gg.png": "./src/assets/images/flags/gg.png",
	"./gh.png": "./src/assets/images/flags/gh.png",
	"./gi.png": "./src/assets/images/flags/gi.png",
	"./gl.png": "./src/assets/images/flags/gl.png",
	"./gm.png": "./src/assets/images/flags/gm.png",
	"./gn.png": "./src/assets/images/flags/gn.png",
	"./gp.png": "./src/assets/images/flags/gp.png",
	"./gq.png": "./src/assets/images/flags/gq.png",
	"./gr.png": "./src/assets/images/flags/gr.png",
	"./gt.png": "./src/assets/images/flags/gt.png",
	"./gu.png": "./src/assets/images/flags/gu.png",
	"./gw.png": "./src/assets/images/flags/gw.png",
	"./gy.png": "./src/assets/images/flags/gy.png",
	"./hawaii.png": "./src/assets/images/flags/hawaii.png",
	"./hk.png": "./src/assets/images/flags/hk.png",
	"./hn.png": "./src/assets/images/flags/hn.png",
	"./hr.png": "./src/assets/images/flags/hr.png",
	"./ht.png": "./src/assets/images/flags/ht.png",
	"./hu.png": "./src/assets/images/flags/hu.png",
	"./id.png": "./src/assets/images/flags/id.png",
	"./ie.png": "./src/assets/images/flags/ie.png",
	"./il.png": "./src/assets/images/flags/il.png",
	"./im.png": "./src/assets/images/flags/im.png",
	"./in.png": "./src/assets/images/flags/in.png",
	"./io.png": "./src/assets/images/flags/io.png",
	"./iq.png": "./src/assets/images/flags/iq.png",
	"./ir.png": "./src/assets/images/flags/ir.png",
	"./is.png": "./src/assets/images/flags/is.png",
	"./it.png": "./src/assets/images/flags/it.png",
	"./je.png": "./src/assets/images/flags/je.png",
	"./jm.png": "./src/assets/images/flags/jm.png",
	"./jo.png": "./src/assets/images/flags/jo.png",
	"./jp.png": "./src/assets/images/flags/jp.png",
	"./ke.png": "./src/assets/images/flags/ke.png",
	"./kg.png": "./src/assets/images/flags/kg.png",
	"./kh.png": "./src/assets/images/flags/kh.png",
	"./ki.png": "./src/assets/images/flags/ki.png",
	"./km.png": "./src/assets/images/flags/km.png",
	"./kn.png": "./src/assets/images/flags/kn.png",
	"./kp.png": "./src/assets/images/flags/kp.png",
	"./kr.png": "./src/assets/images/flags/kr.png",
	"./kw.png": "./src/assets/images/flags/kw.png",
	"./ky.png": "./src/assets/images/flags/ky.png",
	"./kz.png": "./src/assets/images/flags/kz.png",
	"./la.png": "./src/assets/images/flags/la.png",
	"./lb.png": "./src/assets/images/flags/lb.png",
	"./lc.png": "./src/assets/images/flags/lc.png",
	"./li.png": "./src/assets/images/flags/li.png",
	"./lk.png": "./src/assets/images/flags/lk.png",
	"./lr.png": "./src/assets/images/flags/lr.png",
	"./ls.png": "./src/assets/images/flags/ls.png",
	"./lt.png": "./src/assets/images/flags/lt.png",
	"./lu.png": "./src/assets/images/flags/lu.png",
	"./lv.png": "./src/assets/images/flags/lv.png",
	"./ly.png": "./src/assets/images/flags/ly.png",
	"./ma.png": "./src/assets/images/flags/ma.png",
	"./madeira.png": "./src/assets/images/flags/madeira.png",
	"./mc.png": "./src/assets/images/flags/mc.png",
	"./md.png": "./src/assets/images/flags/md.png",
	"./me.png": "./src/assets/images/flags/me.png",
	"./melilla.png": "./src/assets/images/flags/melilla.png",
	"./mg.png": "./src/assets/images/flags/mg.png",
	"./mh.png": "./src/assets/images/flags/mh.png",
	"./mk.png": "./src/assets/images/flags/mk.png",
	"./ml.png": "./src/assets/images/flags/ml.png",
	"./mm.png": "./src/assets/images/flags/mm.png",
	"./mn.png": "./src/assets/images/flags/mn.png",
	"./mo.png": "./src/assets/images/flags/mo.png",
	"./mp.png": "./src/assets/images/flags/mp.png",
	"./mq.png": "./src/assets/images/flags/mq.png",
	"./mr.png": "./src/assets/images/flags/mr.png",
	"./ms.png": "./src/assets/images/flags/ms.png",
	"./mt.png": "./src/assets/images/flags/mt.png",
	"./mu.png": "./src/assets/images/flags/mu.png",
	"./mv.png": "./src/assets/images/flags/mv.png",
	"./mw.png": "./src/assets/images/flags/mw.png",
	"./mx.png": "./src/assets/images/flags/mx.png",
	"./my.png": "./src/assets/images/flags/my.png",
	"./mz.png": "./src/assets/images/flags/mz.png",
	"./na.png": "./src/assets/images/flags/na.png",
	"./nato.png": "./src/assets/images/flags/nato.png",
	"./nc.png": "./src/assets/images/flags/nc.png",
	"./ne.png": "./src/assets/images/flags/ne.png",
	"./nf.png": "./src/assets/images/flags/nf.png",
	"./ng.png": "./src/assets/images/flags/ng.png",
	"./ni.png": "./src/assets/images/flags/ni.png",
	"./nl.png": "./src/assets/images/flags/nl.png",
	"./no.png": "./src/assets/images/flags/no.png",
	"./northen-cyprus.png": "./src/assets/images/flags/northen-cyprus.png",
	"./np.png": "./src/assets/images/flags/np.png",
	"./nr.png": "./src/assets/images/flags/nr.png",
	"./nu.png": "./src/assets/images/flags/nu.png",
	"./nz.png": "./src/assets/images/flags/nz.png",
	"./om.png": "./src/assets/images/flags/om.png",
	"./orkney islands.png": "./src/assets/images/flags/orkney islands.png",
	"./ossetia.png": "./src/assets/images/flags/ossetia.png",
	"./pa.png": "./src/assets/images/flags/pa.png",
	"./pe.png": "./src/assets/images/flags/pe.png",
	"./pf.png": "./src/assets/images/flags/pf.png",
	"./pg.png": "./src/assets/images/flags/pg.png",
	"./ph.png": "./src/assets/images/flags/ph.png",
	"./pk.png": "./src/assets/images/flags/pk.png",
	"./pl.png": "./src/assets/images/flags/pl.png",
	"./pm.png": "./src/assets/images/flags/pm.png",
	"./pn.png": "./src/assets/images/flags/pn.png",
	"./pr.png": "./src/assets/images/flags/pr.png",
	"./ps.png": "./src/assets/images/flags/ps.png",
	"./pt.png": "./src/assets/images/flags/pt.png",
	"./pw.png": "./src/assets/images/flags/pw.png",
	"./py.png": "./src/assets/images/flags/py.png",
	"./qa.png": "./src/assets/images/flags/qa.png",
	"./rapa nui.png": "./src/assets/images/flags/rapa nui.png",
	"./ro.png": "./src/assets/images/flags/ro.png",
	"./rs.png": "./src/assets/images/flags/rs.png",
	"./ru.png": "./src/assets/images/flags/ru.png",
	"./rw.png": "./src/assets/images/flags/rw.png",
	"./sa.png": "./src/assets/images/flags/sa.png",
	"./saba island.png": "./src/assets/images/flags/saba island.png",
	"./sardinia.png": "./src/assets/images/flags/sardinia.png",
	"./sb.png": "./src/assets/images/flags/sb.png",
	"./sc.png": "./src/assets/images/flags/sc.png",
	"./scotland.png": "./src/assets/images/flags/scotland.png",
	"./sd.png": "./src/assets/images/flags/sd.png",
	"./se.png": "./src/assets/images/flags/se.png",
	"./sg.png": "./src/assets/images/flags/sg.png",
	"./sh.png": "./src/assets/images/flags/sh.png",
	"./si.png": "./src/assets/images/flags/si.png",
	"./sint eustatius.png": "./src/assets/images/flags/sint eustatius.png",
	"./sj.png": "./src/assets/images/flags/sj.png",
	"./sk.png": "./src/assets/images/flags/sk.png",
	"./sl.png": "./src/assets/images/flags/sl.png",
	"./sm.png": "./src/assets/images/flags/sm.png",
	"./sn.png": "./src/assets/images/flags/sn.png",
	"./so.png": "./src/assets/images/flags/so.png",
	"./somaliland.png": "./src/assets/images/flags/somaliland.png",
	"./sr.png": "./src/assets/images/flags/sr.png",
	"./ss.png": "./src/assets/images/flags/ss.png",
	"./st.png": "./src/assets/images/flags/st.png",
	"./sv.png": "./src/assets/images/flags/sv.png",
	"./sx.png": "./src/assets/images/flags/sx.png",
	"./sy.png": "./src/assets/images/flags/sy.png",
	"./sz.png": "./src/assets/images/flags/sz.png",
	"./tc.png": "./src/assets/images/flags/tc.png",
	"./td.png": "./src/assets/images/flags/td.png",
	"./tg.png": "./src/assets/images/flags/tg.png",
	"./th.png": "./src/assets/images/flags/th.png",
	"./tibet.png": "./src/assets/images/flags/tibet.png",
	"./tj.png": "./src/assets/images/flags/tj.png",
	"./tk.png": "./src/assets/images/flags/tk.png",
	"./tl.png": "./src/assets/images/flags/tl.png",
	"./tm.png": "./src/assets/images/flags/tm.png",
	"./tn.png": "./src/assets/images/flags/tn.png",
	"./to.png": "./src/assets/images/flags/to.png",
	"./tr.png": "./src/assets/images/flags/tr.png",
	"./transnistria.png": "./src/assets/images/flags/transnistria.png",
	"./tt.png": "./src/assets/images/flags/tt.png",
	"./tv.png": "./src/assets/images/flags/tv.png",
	"./tw.png": "./src/assets/images/flags/tw.png",
	"./tz.png": "./src/assets/images/flags/tz.png",
	"./ua.png": "./src/assets/images/flags/ua.png",
	"./ug.png": "./src/assets/images/flags/ug.png",
	"./um.png": "./src/assets/images/flags/um.png",
	"./united nations.png": "./src/assets/images/flags/united nations.png",
	"./us.png": "./src/assets/images/flags/us.png",
	"./uy.png": "./src/assets/images/flags/uy.png",
	"./uz.png": "./src/assets/images/flags/uz.png",
	"./va.png": "./src/assets/images/flags/va.png",
	"./vc.png": "./src/assets/images/flags/vc.png",
	"./ve.png": "./src/assets/images/flags/ve.png",
	"./vg.png": "./src/assets/images/flags/vg.png",
	"./vi.png": "./src/assets/images/flags/vi.png",
	"./vn.png": "./src/assets/images/flags/vn.png",
	"./vu.png": "./src/assets/images/flags/vu.png",
	"./wales.png": "./src/assets/images/flags/wales.png",
	"./wf.png": "./src/assets/images/flags/wf.png",
	"./ws.png": "./src/assets/images/flags/ws.png",
	"./xk.png": "./src/assets/images/flags/xk.png",
	"./xx.png": "./src/assets/images/flags/xx.png",
	"./xz.png": "./src/assets/images/flags/xz.png",
	"./ye.png": "./src/assets/images/flags/ye.png",
	"./yt.png": "./src/assets/images/flags/yt.png",
	"./za.png": "./src/assets/images/flags/za.png",
	"./zm.png": "./src/assets/images/flags/zm.png",
	"./zw.png": "./src/assets/images/flags/zw.png",
	"./zz.png": "./src/assets/images/flags/zz.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/flags sync recursive ^\\.\\/.*\\.png$";